module.exports = __webpack_public_path__ + "lost.mp3";